
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import SkillSingleInputPlayground from '../../components/Skill/SingleInputOutput/SkillSingleInputPlayground';
import SkillOptions, { Option } from '../../components/Skill/SkillOptions';
import { COOKIE_OPTIONS } from '../../constants/cookies';
import { GPT_3_TOKEN_LENGTH } from '../../constants/gpt3';
import { SUMMARY_TYPE } from '../../constants/options';
import { SKILL_SUMMARIZATION_EXAMPLES } from '../../constants/skillExamples';
import { getFourRandomSkills, SKILL_SUMMARIZATION, SUMMARIZATION_SKILLS, } from '../../constants/skills';
import { useOptionCookie } from '../../hooks/useOptionCookie';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { deleteCookieClient } from '../../utils/cookieHelpers';
import { SkillProvider } from '../../utils/SkillContext';
const SkillSummarization = ({ otherServices }: any) => {
    const { t, lang } = useTranslation('skill-summarization');
    const skillsGroup = SUMMARIZATION_SKILLS;
    const skill = SKILL_SUMMARIZATION;
    const maxLength = 750 * GPT_3_TOKEN_LENGTH;
    const options = [
        { value: SUMMARY_TYPE.SMALL, text: t('skill_summarization_small') },
        { value: SUMMARY_TYPE.MEDIUM, text: t('skill_summarization_medium') },
        { value: SUMMARY_TYPE.LARGE, text: t('skill_summarization_large') },
    ];
    const selectedSummaryType = useOptionCookie('summaryType', options, 2);
    const [selectedOption, setSelectedOption] = useState<Option>(options[2]);
    useEffect(() => {
        setSelectedOption(selectedSummaryType);
        deleteCookieClient(COOKIE_OPTIONS);
    }, [selectedSummaryType]);
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_summarization' description='meta_description_skill_summarization'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <ServiceGroupButtons serviceGroup={skillsGroup}/>
            <SkillProvider skill={skill} skillGroup={skillsGroup} skillExamples={SKILL_SUMMARIZATION_EXAMPLES}>
              <SkillSingleInputPlayground maxLength={maxLength} selectedOption={{ summaryType: selectedOption.value }}>
                <SkillOptions title={t('skill_summarization_subtitle')} options={options} selectedOption={selectedOption} setSelectedOption={setSelectedOption}/>
              </SkillSingleInputPlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillSummarization;

    async function __Next_Translate__getStaticProps__19bb2fd5b92__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/summarization/summarization',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b92__ as getStaticProps }
  